import React from 'react';

export default function Logo({ white = false, onHomeClick }) {
  return (
    <div 
      className="flex items-center gap-3 cursor-pointer hover:opacity-80 transition-opacity"
      onClick={onHomeClick}
      role="button"
      tabIndex={0}
      onKeyPress={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onHomeClick?.();
        }
      }}
    >
      <img src="/logo.png" alt="GOmax Logo" className="h-12" />
    </div>
  );
}